import Vue from "vue";
import Vuex from "vuex";
import axios from "../plugins/axios";
import i18n from "@/i18n";
import dayjs from "dayjs";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    eventId: 0,
    language: "en",
    calendarKey: 1,
    calendarSettings: [],
    calendarStartingDate: null,
    calendarEvents: [],
    calendarEventsDetail: [],
    daySelected: [],
    timeSlotSelected: [],
    sessionsPerDayOfWeekSelected: [],
    daysOfWeekSelected: [],
    sessionsPerTypeSelected: {
      video: [],
      poster: [],
    },
    sessionsPerTypeSelectedIsLoading: false,
    sessionTypeSelected: "",
    sessionSelected: {},
    isSessionSelectedDetailsLoading: false,
    sessionSelectedDetails: {},
    sessionAbstract: {},
    // hasLoadedDays: [], //keep track dou jen suis dans le loading.
    // Comme ca peut "stop" le loading pour load day selected avant de continuer
    // le loading des autres (lower priority) - en theory lol.
    isLazyLoaded: false, //keep track de si lazy load est done.
    isHeavyLoaded: false, //keep track de si heavy load est done.
    isSettingLoaded: false,
  },
  mutations: {
    SET_EVENT_SELECTED(state, payload) {
      state.eventId = payload;
    },
    SET_LANGUAGE(state, payload) {
      state.language = payload;
    },
    SET_CALENDAR_KEY(state) {
      state.calendarKey = state.calendarKey + 1;
    },
    SET_CALENDAR_EVENTS(state, payload) {
      state.calendarEvents = payload;
    },
    SET_CALENDAR_EVENTS_DETAIL(state, payload) {
      state.calendarEventsDetail = payload;
    },
    SET_DAY_SELECTED(state, payload) {
      state.daySelected = payload;
    },
    SET_IS_SETTING_LOADED(state, payload) {
      state.isSettingLoaded = payload;
    },
    SET_TIMESLOT_SELECTED(state, payload) {
      state.timeSlotSelected = payload;
    },
    SET_DAYSOFWEEK_SELECTED(state, payload) {
      state.daysOfWeekSelected = payload;
    },
    SET_SESSION_SELECTED(state, payload) {
      state.sessionSelected = payload;
    },
    SET_ISSECTIONSELECTEDDETAILS_LOADING(state) {
      state.isSessionSelectedDetailsLoading = true;
    },
    SET_SESSION_SELECTED_DETAILS(state, payload) {
      state.sessionSelectedDetails = payload;
      state.isSessionSelectedDetailsLoading = false;
    },
    SET_SESSIONS_PERDAYOFWEEKSELECTED(state, payload) {
      state.sessionsPerDayOfWeekSelected = payload.data;
    },
    SET_SESSIONS_PERTYPESELECTED(state, payload) {
      state.sessionsPerTypeSelected[payload.param] = payload.data;
      state.sessionsPerTypeSelectedIsLoading = false;
    },
    SET_SESSIONS_PERTYPESELECTED_ISLOADING(state) {
      state.sessionsPerTypeSelectedIsLoading = true;
    },
    SET_SESSIONTYPE_SELECTED(state, payload) {
      state.sessionTypeSelected = payload;
    },
    SET_SESSION_ABSTRACT(state, payload) {
      state.sessionAbstract = payload;
    },
    SET_CALENDAR_SETTINGS(state, payload) {
      state.calendarSettings = payload;
    },
    SET_CALENDAR_STARTING_DATE(state, payload) {
      state.calendarStartingDate = payload;
    },
  },
  actions: {
    fetchDay(context, payload) {
      if (payload.day == null) payload.day = "onlinesession";

      return new Promise((resolve, reject) => {
        axios
          .get(
            `/Calendar/${context.getters.getLanguage}/${context.getters.getEventId}/${payload.day}?trackIds=${payload.trackIds}&allDay=${payload.allDay}`
          )
          .then((res) => {
            context.commit("SET_SESSIONS_PERDAYOFWEEKSELECTED", {
              data: res.data,
            });
            resolve();
          })
          .catch((e) => reject(e));
      });
    },
    fetchCalendarSettings(context) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `/Calendar/${context.getters.getLanguage}/${context.getters.getEventId}/settings`
          )
          .then((res) => {
            context.commit("SET_CALENDAR_SETTINGS", res.data);
            context.commit("SET_IS_SETTING_LOADED", res.data);
            resolve();
          })
          .catch((e) => reject(e));
      });
    },
    fetchCalendarEvents(context) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `/Calendar/${context.getters.getLanguage}/${context.getters.getEventId}`
          )
          .then((res) => {
            context.commit("SET_CALENDAR_EVENTS", res.data);
            context.commit("SET_CALENDAR_KEY");
            context.dispatch("compileEventDetails");
            resolve();
          })
          .catch((e) => reject(e));
      });
    },
    compileEventDetails(context) {
      const events = [];

      for (let i = 0; i < context.getters.getCalendarEvents.length; i++) {
        //check if has event duration full day for positioning
        //color
        let backgroundcolor =
          context.getters.getCalendarEvents[i].backgroundColor;
        let foregroundcolor =
          context.getters.getCalendarEvents[i].foregroundColor;

        if (
          context.getters.getCalendarEvents[i].end == null ||
          context.getters.getCalendarEvents[i].end == ""
        ) {
          events.push({
            name: context.getters.getCalendarEvents[i].name,
            start: dayjs(context.getters.getCalendarEvents[i].start).format(
              "YYYY-MM-DD"
            ),
            end: null,
            textcolor: foregroundcolor,
            color: backgroundcolor,
            url: context.getters.getCalendarEvents[i].url,
            duration: null,
            trackIds: context.getters.getCalendarEvents[i].trackIds
          });
        } else {
          events.push({
            name: context.getters.getCalendarEvents[i].name,
            start: context.getters.getCalendarEvents[i].start,
            end: context.getters.getCalendarEvents[i].end,
            textcolor: foregroundcolor,
            color: backgroundcolor,
            url: context.getters.getCalendarEvents[i].url,
            duration: dayjs(context.getters.getCalendarEvents[i].end).diff(
              dayjs(context.getters.getCalendarEvents[i].start),
              "minute"
            ),
            trackIds: context.getters.getCalendarEvents[i].trackIds
          });
        }
      }

      context.commit("SET_CALENDAR_EVENTS_DETAIL", events);
    },
    fetchSessionsPerDayOfWeekSelected(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/Calendar/day/${payload.day}`, {
            params: {
              groupResult: true,
            },
          })
          .then((res) => {
            context.commit("SET_SESSIONS_PERDAYOFWEEKSELECTED", {
              data: res.data,
            });
            resolve();
          })
          .catch((e) => {
            console.log(e), reject(e);
          });
      });
    },
    fetchSessionsPerTypeSelected(context, payload) {
      return new Promise((resolve, reject) => {
        context.commit("SET_SESSIONS_PERTYPESELECTED_ISLOADING");
        axios
          .get(`/Calendar/type/${payload.type}`, {
            params: {
              groupResult: true,
            },
          })
          .then((res) => {
            context.commit("SET_SESSIONS_PERTYPESELECTED", {
              param: payload.type,
              data: res.data,
            });
            resolve();
          })
          .catch((e) => {
            console.log(e), reject(e);
          });
      });
    },
    fetchSessionSelectedDetails(context, payload) {
      context.commit("SET_ISSECTIONSELECTEDDETAILS_LOADING");
      return new Promise((resolve, reject) => {
        axios
          .get(
            `/Calendar/${context.getters.getLanguage}/${context.getters.getEventId}/session/${payload.id}`
          )
          .then((res) => {
            context.commit("SET_SESSION_SELECTED_DETAILS", res.data);
            resolve();
          })
          .catch((e) => {
            console.log(e), reject(e);
          });
      });
    },
    fetchDownloadSessionAbstract(context, payload) {
      return new Promise((resolve, reject) => {
        axios({
          url: `/Calendar/${context.getters.getLanguage}/${context.getters.getEventId}/download/${payload.id}`,
          method: "GET",
          responseType: "blob", // important
        })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;

            // Regular expression to match the 'filename' parameter
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;

            // Regular expression to match the 'filename*' parameter
            const filenameStarRegex =
              /filename\*[^;=\n]*=((['"]).*?\2|[^;\n]*)/;

            const contentDisposition = response.headers["content-disposition"];
            // Extract the 'filename' parameter
            const matches = filenameRegex.exec(contentDisposition);
            let filename = null;
            if (matches && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }

            // If 'filename' parameter is not found, try to extract 'filename*' parameter
            if (!filename) {
              const matchesStar = filenameStarRegex.exec(contentDisposition);
              if (matchesStar && matchesStar[1]) {
                // Decode the URL-encoded filename
                filename = decodeURIComponent(matchesStar[1]);
              }
            }

            let fileExtension = "";
            const lastDotIndex = filename.lastIndexOf(".");
            if (lastDotIndex === -1) {
              // If there's no dot in the filename, return an empty string or handle the case as you prefer
            } else {
              fileExtension = filename.substring(lastDotIndex).toLowerCase();
            }

            link.setAttribute("download", payload.eventname + fileExtension); //or any other extension
            document.body.appendChild(link);
            link.click();
          })
          .catch((e) => {
            console.log(e), reject(e);
          });
      });
    },
    changeCalendarStartingDate({ commit }, payload) {
      commit("SET_CALENDAR_STARTING_DATE", payload);
    },
    changeDaySelected({ commit }, payload) {
      commit("SET_DAY_SELECTED", payload);
    },
    changeSessionTypeSelected({ commit }, payload) {
      commit("SET_SESSIONTYPE_SELECTED", payload);
    },
    changeTimeSlotSelected({ commit }, payload) {
      commit("SET_TIMESLOT_SELECTED", payload);
    },
    changeDaysOfWeekSelected({ commit }, payload) {
      commit("SET_DAYSOFWEEK_SELECTED", payload);
    },
    changeSessionSelected({ commit }, payload) {
      commit("SET_SESSION_SELECTED", payload);
    },
    changeLanguage({ commit }, payload) {
      if (payload == undefined) payload = "en"; //Default to english

      i18n.locale = payload;
      commit("SET_LANGUAGE", payload);
    },
    changeEventSelected({ commit }, payload) {
      commit("SET_EVENT_SELECTED", payload);
    },
  },
  getters: {
    getSettings: (state) => state.calendarSettings,
    getLanguage: (state) => state.language,
    getEventId: (state) => state.eventId,
    getCalendarStartingDate: (state) => state.calendarStartingDate,
    getCalendarEvents: (state) => state.calendarEvents,
    getCalendarEventsDetail: (state) => state.calendarEventsDetail,
    getDaysOfWeekSelected: (state) => state.daysOfWeekSelected,
    getSessionTypeSelected: (state) => state.sessionTypeSelected,
    getSessionsPerTypeSelected: (state) => state.sessionsPerTypeSelected,
    getSessionsPerTypeSelectedIsLoading: (state) =>
      state.sessionsPerTypeSelectedIsLoading,
    getSessionsPerDayOfWeekSelected: (state) =>
      state.sessionsPerDayOfWeekSelected,
    getIsLazyLoaded: (state) => state.isLazyLoaded,
    getIsHeavyLoaded: (state) => state.isHeavyLoaded,
    getIsSettingLoaded: (state) => state.isSettingLoaded,
    getDaySelected: (state) => state.daySelected,
    getTimeSlotSelected: (state) => state.timeSlotSelected,
    getSessionSelected: (state) => state.sessionSelected,
    getSessionSelectedDetails: (state) => state.sessionSelectedDetails,
    getIsSessionSelectedDetailsLoading: (state) =>
      state.isSessionSelectedDetailsLoading,
  },
  modules: {},
});
